import { defineCopy } from "@tami/core/intl";

import { WEB_ERRORS_COPY_EN_US } from "./en-us/web-errors.copy";
import { WEB_ERRORS_COPY_ES_ES } from "./es-es/web-errors.copy";

/** Mensagens de erro e de dado inválido só-web, compartilhadas entre serviços e libs. */
export const WEB_ERRORS_COPY_PT_BR = {
  unexpected: "Ocorreu um erro inesperado. Por favor, tente novamente.",
  sessionNotFound: "Sessão não encontrada",
  sessionNotFoundDot: "Sessão não encontrada.",
  passwordVerifyFailed: "Não foi possível verificar a senha",
  sessionRenewFailed: "Não foi possível renovar a sessão.",
  signUpFailed: "Erro ao realizar o cadastro",
  uploadImageFailed: "Não foi possível enviar a imagem.",
  uploadImageFailedRetry: "Não foi possível enviar a imagem. Tente novamente.",
  roteiroLoadFailed: "Não foi possível carregar o roteiro. Tente novamente.",
  invalidDate: "Data inválida",
  collabNoAccess: "Você não tem acesso a este conteúdo do influenciador.",
  widget: {
    title: "Houve um erro",
    description: "Não foi possível carregar as informações.",
    retry: "Tentar novamente",
  },
} as const;

export const WEB_ERRORS_COPY = defineCopy(WEB_ERRORS_COPY_PT_BR, {
  "en-US": WEB_ERRORS_COPY_EN_US,
  "es-ES": WEB_ERRORS_COPY_ES_ES,
});
